<template>
	<div class="container-fluid">

		<time-logs-toolbar heading="Pay Period Reports"></time-logs-toolbar>

		<table-list
			:loading="loading"
			:records="periods"
			:fields="fields"
			:other-buttons="otherButtons"
			id-field="slug"
			:sortable="true"
			record-name="Pay Period">

			<div class="d-flex flex-row align-items-start flex-wrap">
				<field label="Include processed periods" 
					class="mr-2"
					col-class="col-auto" 
					v-model="showProcessed" 
					:params="{type:'boolean'}"
					v-on:change="showProcessedChange">
				</field>

				<button class="btn btn-light" v-on:click="genModal.visible = true">
					Generate a Pay Period Report
				</button>
			</div>

		</table-list>

		<modal-dialog
			:modal-visible="genModal.visible"
			title="Generate Pay Period Report"
			confirm-button-text="Generate Report"
			:working="genModal.working"
			v-on:closeModal="genModal.visible = false"
			v-on:confirm="manualReportGenerate">

			<field v-if="!genModal.working" 
				label="Please select the starting date for the pay period"
				col-class="stacked"
				:params="{type:'date'}"
				v-model="genModal.periodStart">
			</field>

			<div v-if="genModal.working" class="text-center">
				<div class="text-center">
					<i class="fa fa-sync fa-spin fa-3x"></i>
				</div>
				{{genModal.msg}}
			</div>

		</modal-dialog>

	</div>
</template>

<script>
import TimeLogsToolbar from "./TimeLogsToolbar"
import TableList from "../../components/TableList"
import Field from "../../components/Field"
import ModalDialog from "../../components/ModalDialog"

export default {
	name: 'TimeLogHistory',
	components: {
		TimeLogsToolbar,
		TableList,
		Field,
		ModalDialog
	},
	data() {
		return {
			logs: [],
			payPeriods: [],
			jobs: [],
			showProcessed: 0,
			TimeLogSettings: {},
			fields: [
				{label: "Pay Period",key: "label"},
				{label: "Processed",key:'processed',type:'boolean'},
				{label: "Generated By",key:"generatedBy"},
				//{label: "PDF",key:"pdf"},
				{label: "Last Generated",key:'lastGenerated'}
				//{label: "CSV",key:"csv"}
			],
			otherButtons: [
				{
					link: '/time-logs/submitted/{?}/detailed',
					icon: 'fa-eye',
					text: 'View',
					class: 'btn-primary'
				}
			],
			genModal: {
				visible: false,
				periodStart: null,
				working: false,
				msg: ""
			},
			loading: true
		}
	},
	computed: {
		periods() {
			let vm = this

			return this.payPeriods.map(record => {

				record.pdf = "<a href='" + window.apiBase + "PayPeriod/pdf?token="+vm.$store.sessionToken+"&type=TimeLog&start_date=" + record.start + "'>PDF</a>"

				record.csv = "<a href='#'>TO-DO</a>"

				let start = vm.moment(record.start).format("MMM D")
				let end = vm.moment(record.end).format("MMM D")

				record.label = start + " to "+ end

				record.generatedBy = ""
				if (record.system_generated == 1)
					record.generatedBy = "System"
				else if (record.User)
					record.generatedBy = record.User.first_name+" "+record.User.last_name

				if (record.generation_completed_at == "0000-00-00 00:00:00") 
					record.lastGenerated = "<span class='text-danger'><i class='fa fa-hourglass'></i> In-progress...</span>"
				else if (record.generation_completed_at == null) //this is to handle legacy timestamps before generation_completed_at existed
					record.lastGenerated = vm.formatDateTimeToLocal(record.created_at)
				else
					record.lastGenerated = vm.formatDateTimeToLocal(record.generation_completed_at)
				
				if (record.generation_completed_at != "0000-00-00 00:00:00" && record.updated_at != "0000-00-00 00:00:00" && record.updated_at != null)
					record.lastGenerated = vm.formatDateTimeToLocal(record.updated_at)

				return record
			})
		}
	},
	methods: {
		manualReportGenerate() {
			//find last pay period so we can figure out the start of the next
			let vm = this

			this.genModal.working = true
			this.genModal.msg = "The report is being generated. This may take a few minutes, you may navigate away and come back later."

			this.postData("PayPeriod/save",{period_start: this.genModal.periodStart}).then(response => {

				if (!response.success) {
					vm.alertErrors(response.errors)
					vm.genModal.working = false
				}

				else {
					vm.genModal.msg = "Report generation complete. Fetching..."
					vm.fetchPayPeriods()
					vm.alertSuccess("New Pay Period Report successfully generated!")
					vm.genModal.visible = false
				}
				

			})

		},
		showProcessedChange() {
			this.$nextTick(() => {
				this.fetchPayPeriods(true)
			})
		},
		fetchPayPeriods(spinner) {
			let vm = this

			let filters = []

			if (!this.showProcessed)
				filters.push(["processed",0])

			if (spinner) {
				vm.spinner(true)
				vm.loading = true
			}

			let params = {
				filters,
				fields:  ["start","end","slug","id","processed","created_at","updated_at","created_by","system_generated","generation_completed_at"],
				include: ["User"],
				orders:[["start","DESC"]]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("PayPeriod/get",params).then(response => {

					vm.payPeriods = response.data

					vm.loading = false

					if (spinner) {
						vm.spinner(false)
					}

					vm.genModal.working = false

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this 

			this.spinner(true)

			let promises = [
				this.fetchPayPeriods(false),
				this.getJSON("Job/get",{include:["JobPersonnelRole"]})
			]

			Promise.all(promises).then(responses => {

				vm.payPeriods = responses[0].data
			
				let jobs = responses[1].data

				vm.spinner(false)
			
			})
		}
	},
	created() {
		this.fetchData();
	}
}
</script>
